import * as React from 'react'

import { Box, DescriptionType, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import hands from './icons/hands.svg'

export interface ModalDescriptionProps {
  description?: DescriptionType
  isLoading?: boolean
  notified?: boolean
  success?: boolean
  title?: string
  customSuccessDescription?: string
  icon?: string
}

const ModalDescription = ({
  description,
  isLoading = false,
  success,
  title,
  customSuccessDescription,
  icon,
}: ModalDescriptionProps) => {
  if (isLoading)
    return (
      <Box alignItems="center" height="s120" justifyContent="center">
        <Spinner />
      </Box>
    )

  if (success) {
    return (
      <Box alignItems="center" gap="s12">
        <img width="120px" src={hands} />
        <Box gap="s24">
          <Text.Normal size="300" overflowWrap>
            {customSuccessDescription || i18n.t('upsell.request_modal.success_description')}
          </Text.Normal>
        </Box>
      </Box>
    )
  }

  return (
    <Box alignItems="center" gap="s12">
      <img width="120px" src={icon} />
      <Box alignItems="center" textAlign="center">
        <Text.Header2>{title}</Text.Header2>
      </Box>
      <Box alignItems="center" textAlign="center">
        <Text.Normal size="300" overflowWrap>
          {description}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default ModalDescription
